@if (!item.hidden) {
    <div class="group-title" [ngClass]="item.classes">
        <span class="hint-text" [translate]="item.translate">{{ item.title }}</span>
    </div>
    <div class="group-items">
        @for (item of item.children; track $index) {
            @switch ( item.type) {
                @case ('group') {
                    <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
                }
                @case ('collapsable') {
                    <fuse-nav-vertical-collapsable [item]="item"></fuse-nav-vertical-collapsable>
                }
                @case ('item') {
                    <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
                }
            }
        }
    </div>
}
